import { useMutation } from "@apollo/client/react";
import { formatDuration } from "components/helpers/format";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import { DeleteTeardownTime } from "./teardownTime.gql";

export default function useDeleteTeardownTime() {
  const { setNotification } = useNotificationState();
  const [deleteTeardownTime] = useMutation(DeleteTeardownTime, {
    onCompleted: ({ deleteTeardownTime: { duration, label } }) => {
      const formattedDuration = formatDuration(duration);
      const errorText = `${label} (${formattedDuration})`;

      setNotification({
        title: `${errorText} was successfully deleted.`,
        type: "success",
      });
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to delete teardown time",
          type: "danger",
        });
      });
    },
  });

  return (options) => deleteTeardownTime(options);
}
